import { RotationRow } from 'src/pages/ConvenienceDispatches/adapter';
import { VehicleRowCardVM } from 'src/pages/ConvenienceDispatches/vehicleRowVM';

/** 判定に使う行の最小情報。回転 (cycle) ごとのカード列を持つ */
export type NewlyAssignedRow = Pick<RotationRow, 'shiftTruckId'> & {
  source: { cards: readonly Pick<VehicleRowCardVM, 'legRuns'>[] };
};

/**
 * この行（= その回転）に新しく割り付いた案件が乗っているか。
 *
 * 差分 (newlyAssignedByShiftTruck) は勤務 (shift_truck) 単位なので、そのまま使うと
 * 2 回転目に案件が入っただけで同じ勤務の 1 回転目まで光る (log_web_issues#297)。
 * 行が実際に持っている案件と突き合わせて、増えた案件が乗っている回転だけを光らせる。
 *
 * Why not 回転番号 (cycle) で引き直す: `rotationNumber` は「回転を追加」の仮想行や
 * 固定ルートの placeholder を隠したときに連番でなくなる（RotationRow の
 * displayRotationNumber のコメント参照）。行が持つ案件で照合すれば番号に依存しない。
 */
export function isRowNewlyAssigned(
  row: NewlyAssignedRow,
  newlyAssignedByShiftTruck: ReadonlyMap<number, ReadonlySet<number>> | undefined,
): boolean {
  const { shiftTruckId } = row;
  if (shiftTruckId == null) return false;

  const newlyAssigned = newlyAssignedByShiftTruck?.get(shiftTruckId);
  if (!newlyAssigned || newlyAssigned.size === 0) return false;

  // Why not card.legRuns?.some(...): VehicleRowCardVM.legRuns は必須フィールドで、
  // 生成箇所すべてが必ず配列を入れている（no_delivery と再積み込み拠点は `[]`、
  // template は突合した legRun、実 operation 由来は `legRun ? [legRun] : []`）。
  // 型を迂回する cast も無いので、オプショナルチェインは到達しない分岐になる。
  return row.source.cards.some(
    (card) => card.legRuns.some((legRun) => newlyAssigned.has(legRun.shipment_order_id)),
  );
}
